<template>
  <BaseModal modal-content-class="login">
    <div class="content">
      <BaseImage src="/static/images/info.svg" alt="info" />

      <p>{{ $_translations.value.modal_pin_description }}</p>

      <p>
        {{ $_translations.value.modal_pin_request_new_pt1 }}
        <a
          href="#"
          class="text_links login"
          @click.prevent="$emit('redirect:forgotPassword')"
        >
          {{ $_translations.value.modal_pin_request_new_pt2 }}
        </a>
      </p>
    </div>
  </BaseModal>
</template>

<script setup>
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['redirect:forgotPassword']);
</script>
